import axios from 'axios';
import { config } from 'src/config/config';

export const getPublicCodesFetcher = (data: any) =>
  axios.post(`${config.api}/vk/get-public-codes`, data, { withCredentials: true });

export const addPublicCodes = (data: any) =>
  axios.post(`${config.api}/vk/public-codes/add`, data, { withCredentials: true });
